<template>
  <div>
    <vs-chip v-if="data.member" color="primary" class="mr-2">
      Member
    </vs-chip>
    <vs-chip v-if="data.staff" color="warning" class="mr-2">
      Staff
    </vs-chip>
    <vs-chip v-if="data.marketing" color="#24c1a0" class="mr-2">
      Marketing
    </vs-chip>
    <vs-chip v-if="data.admin" color="danger">
      Admin
    </vs-chip>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    }
  }
}
</script>
